/**
 * The paragraph the Slack connection wrote in front of the owner's words before
 * 3 Oct 2026. It is kept here for one purpose: migration 085 recognises it, once,
 * to record on each stored legacy message how long its connection prefix is.
 * Nothing recognises it by its words afterwards.
 */
export const LEGACY_SLACK_OWNER_WRAPPER =
  "You are Cleo, speaking with your owner through Slack. Your final plain-text answer will be posted to the same Slack conversation. Keep the existing human approval gates. Do not send the reply separately or claim delivery.\n\nOwner message:\n";

/**
 * The person's words from a stored message: its text minus the connection
 * prefix recorded for it (`connectionPrefixLength`), or the text itself when no
 * prefix is recorded. Every place that presents or carries a person's words
 * from stored rows uses this one function; stored text is never rewritten. Only
 * messages that existed when migration 085 ran carry a recorded prefix, so a
 * message written since, whatever its text, is returned whole.
 */
export function withoutConnectionPrefix(
  text: string,
  connectionPrefixLength: number | null | undefined,
): string {
  return typeof connectionPrefixLength === "number" &&
    Number.isInteger(connectionPrefixLength) &&
    connectionPrefixLength > 0 &&
    connectionPrefixLength <= text.length
    ? text.slice(connectionPrefixLength)
    : text;
}
